module.exports = __webpack_public_path__ + "img/navercloud.3da4590d.svg";